import React from 'react';
import Layout from '../layout';
import RetailSectionOne from '../components/Esper/Retail/RetailSectionOne';
import RetailSectionTwo from '../components/Esper/Retail/RetailSectionTwo';
import RetailSectionThree from '../components/Esper/Retail/RetailSectionThree';
import RetailSectionFive from '../components/Esper/Retail/RetailSectionFive';
import RetailBg from '../assets/v2/png/retail_hero.jpg';
import messages from '../i18n/en';

export default (props: any) => (
  <Layout
    ogImage={RetailBg}
    messages={messages}
    location={props.location}
    title={'Android Device Management Platform for Retail Industry'}
    description={`Retailers rely on Esper's Device Management Solution to scale. Esper's platform features support Android PoS, retail kiosks, restaurant devices, and more. `}
    keywords={`"Device Management Solutions for retail,kiosk retail software,retail kiosk software,MDM Retail,restaurant device software,POS devices,mobile application management"`}
  >
    <RetailSectionOne />
    <RetailSectionTwo />
    <RetailSectionThree />
    <RetailSectionFive />
  </Layout>
);
